module.exports = __webpack_public_path__ + "img/Lage_TheGate&TheHall.283a8a59.svg";